import { Link } from 'react-router-dom';
import { kanal } from '@beholder/shared';
import { betrag, type BudgetKurz } from '@beholder/shared/module/budget';
import { api } from '../../core/api';
import { useLive } from '../../core/live';
import type { ModulSeiteProps, WebModul } from '../../core/modul';
import { Symbol } from '../../core/symbole';
import { Karte as KarteRahmen, useDaten } from '../../core/ui';
import { PlanLeiste, WarnMarke } from './Diagramme';
import { pfad } from './hilfe';
import { Seite } from './Seite';
import './stil.css';

/** Kleine Karte für die Projektübersicht. */
function Karte({ projekt }: ModulSeiteProps) {
  const { daten: k, neuLaden } = useDaten(() => api.get<BudgetKurz>(pfad(projekt.id, '/kurz')), [projekt.id]);
  useLive(kanal(projekt.id, 'budget'), () => void neuLaden());
  const w = 'EUR'; // Projektwährung ist fest Euro
  return (
    <KarteRahmen titel={<Link to={`/p/${projekt.id}/budget`} className="bu-karte-titel">{Symbol.budget} Budget</Link>}>
      {!k ? (
        <p className="leise">Lädt …</p>
      ) : (
        <div className="stapel bu-karte">
          <div className="reihe">
            <strong className="bu-gross">{betrag(k.gesamt.istCent, w)}</strong>
            <span className="leise">{k.gesamt.planCent === null ? 'ausgegeben' : `von ${betrag(k.gesamt.planCent, w)}`}</span>
          </div>
          <PlanLeiste planCent={k.gesamt.planCent} istCent={k.gesamt.istCent} angeboteCent={k.gesamt.angeboteCent} warnung={k.gesamt.warnung} waehrung={w} />
          <div className="leise klein">
            {k.gesamt.restCent !== null && <>Rest {betrag(k.gesamt.restCent, w)} · </>}
            {k.gesamt.angeboteCent > 0 && <>offene Angebote {betrag(k.gesamt.angeboteCent, w)} · </>}
            {k.offeneRechnungen} offene {k.offeneRechnungen === 1 ? 'Rechnung' : 'Rechnungen'}
          </div>
          {k.gesamt.einnahmenCent !== 0 && (
            <div className="leise klein">
              Einnahmen {betrag(k.gesamt.einnahmenCent, w)} · Saldo{' '}
              <span className={k.gesamt.saldoCent < 0 ? 'bu-text-gefahr' : 'bu-text-ok'}>{betrag(k.gesamt.saldoCent, w)}</span>
            </div>
          )}
          <div className="reihe">
            <WarnMarke warnung={k.gesamt.warnung} />
            {k.ueberschritten.slice(0, 3).map((u) => (
              <span key={u.name} className="bu-marke bu-marke-gefahr" title={`${betrag(-u.restCent, w)} über Budget`}>
                {u.name}
              </span>
            ))}
            {k.vorschlaege > 0 && (
              <Link to={`/p/${projekt.id}/budget/vorschlaege`} className="bu-marke bu-marke-akzent">
                {k.vorschlaege} {k.vorschlaege === 1 ? 'Vorschlag' : 'Vorschläge'}
              </Link>
            )}
          </div>
        </div>
      )}
    </KarteRahmen>
  );
}

const budget: WebModul = { id: 'budget', name: 'Budget', reihenfolge: 40, symbol: Symbol.budget, Seite, Karte };
export default budget;
